import styled from 'styled-components'

import { CustomButton } from '../../../../styles/global'
import { CardContainer, CardSkeleton, CardWrapper } from '../../../../components/Card/styles'
import { AlertContainer as ContainerAlert } from '../../../../components/Form/Alert'
import { Container as ContainerCheckBox } from '../../../../components/Form/Checkbox'

export const Container = styled.div`
  display: flex;
  width:100%;
  border-top: 1px solid #DADADA;
`

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
`

export const Button = styled(CustomButton)`
  font-family: 'Open Sans';
  font-style: normal;
  font-size: 16px;
  font-weight: 600;
  line-height: 19.2px;
  border: none;
  align-items: center;
  gap: 16px;
  color: #028BB7;
  margin-bottom: 8px;
  justify-content: start;

  svg {
    margin-right: 0;
  }
`

export const StyledCard = styled.div`
  display: flex;
  width: 100%;

  ${ContainerAlert}{
    margin-bottom: 16px;
  }
  ${CardContainer}{
    box-sizing: border-box;
    align-items: flex-start;
    width: 100%;
    border: 1px solid #DADADA;
    box-shadow: none;
    gap: 0;
  }
  ${CardWrapper}{
    width: 100%;
    margin: 0;
    margin-top: 24px;
  }
  ${CardSkeleton}{
    width: 100%;
    min-height: 99px;
  }
  ${CardSkeleton}:first-child {
    min-height: 137px;
  }
`

export const Category = styled.div`
  display: flex;
  padding: 6px 8px;
  ${props => props.backgroundColor ? `background-color: ${props.backgroundColor};` : 'background-color: #E0F8F9;'}
  border-radius: 8px;
  flex: 1;
  ${props => props.official ? 'margin: 16px 0;' : 'margin: 0 0 16px'}
`

export const CategoryName = styled.h2`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: normal;
  ${props => props.color ? `color: ${props.color};` : 'color: #01878E;'}
  margin-bottom: 0;
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  max-width: 100%;
  gap: 16px;
`

export const Subtitle = styled.h2`
  color: #000;
  font-family: 'Open Sans';
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.96px;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  overflow: hidden;
  margin: 0;
`

export const Text = styled.p`
  color: #555;
  white-space: pre-wrap;
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  ${props => props.hasMargin && 'margin-left: 8px'};
  margin-bottom: 0px;

  strong {
    font-family: 'Open Sans';
    color: #028BB7;
    font-weight: 600;
  }
`

export const Label = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  ${ContainerCheckBox}{
    height: 21px;
    & label{
      position: relative;
      padding-left: 17px;
    }
  }
`
